import createFetchClient from 'openapi-fetch'
import createClient from 'openapi-react-query'
import type { Middleware } from 'openapi-fetch'
import type { paths } from './schema'
import { env } from '@/env'

const authMiddleware: Middleware = {
  onRequest({ request }) {
    const stored = localStorage.getItem('auth.user')
    const user = stored ? JSON.parse(stored) : null
    if (user) {
      request.headers.set('Authorization', `Bearer ${user.accessToken}`)
    }
    return request
  },
}

const fetchClient = createFetchClient<paths>({
  baseUrl: import.meta.env.PROD ? env.VITE_APP_API_URL : '/api',
})
fetchClient.use(authMiddleware)

const $api = createClient(fetchClient)

export default $api
